import { render, staticRenderFns } from "./prefix-gallery.vue?vue&type=template&id=a096cad2&scoped=true&"
import script from "./prefix-gallery.vue?vue&type=script&lang=js&"
export * from "./prefix-gallery.vue?vue&type=script&lang=js&"
import style0 from "./prefix-gallery.vue?vue&type=style&index=0&id=a096cad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a096cad2",
  null
  
)

export default component.exports